import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceStatus, TDeviceStatus } from '~/providers/types/deviceStatus';
import { Badge } from '~/pages/Analysis/Units/UnitDetail/StatusBadge/Badge';

interface DeviceStatusBadgeProps {
  deviceStatus?: TDeviceStatus | null;
}

export function DeviceStatusBadge({
  deviceStatus,
}: Readonly<DeviceStatusBadgeProps>): ReactElement | null {
  const { t } = useTranslation();
  function renderLabel(): string {
    if (deviceStatus === DeviceStatus.MACHINE_WITHOUT_ENERGY) {
      return t('maquinaDesernergizada');
    }

    if (deviceStatus === DeviceStatus.FORCED_UNINSTALL) {
      return t('desinstalacaoForcada');
    }

    if (deviceStatus === DeviceStatus.DEVICE_REMOVED) {
      return t('dispositivoRemovido');
    }

    return '';
  }

  if (deviceStatus && deviceStatus !== DeviceStatus.OPERATION) {
    return (
      <div>
        <Badge label={renderLabel()} />
      </div>
    );
  }

  return null;
}
